export const formAddress = (address) =>
  Object.values(address).filter(Boolean).join(", ");
